import { defineMessages } from 'react-intl';

export default defineMessages({
  searchPlaceholder: {
    id: 'neptune.Select.searchPlaceholder',
    defaultMessage: 'Search...',
  },
});
